// MAKE HOVER = CLICK FOR DESKTOP PRODUCT THUMBNAILS
// const productThumbnails = document.querySelectorAll(".product-gallery__thumbnail");
// if (productThumbnails.length > 0) {
//   productThumbnails.forEach((thumbnail) => {
//     let hoverTimeout;

//     thumbnail.addEventListener("mouseenter", function () {
//       hoverTimeout = setTimeout(() => {
//         // Check if the cursor is still on the element
//         if (thumbnail.matches(':hover')) {
//           thumbnail.click();
//         }
//       }, 150);
//     });

//     thumbnail.addEventListener("mouseleave", function () {
//       clearTimeout(hoverTimeout);
//     });
//   });
// }



// UPDATE REBUY CART VARIANT TITLE
const updateRebuyCartVariantTitles = () => {
  const variantTitleMap = {
    "Brown": "Caffe",
    "Grey": "Stone",
    "Green": "Olive"
  };

  const elements = document.querySelectorAll('.rebuy-cart__flyout-item-variant-title');

  elements.forEach((element) => {
    const currentText = element.innerText.trim();
    if (variantTitleMap[currentText]) {
      element.innerText = variantTitleMap[currentText];
    }
  });
};

const scheduleRebuyCartUpdates = () => {
  const delays = [200, 500, 1000];
  delays.forEach(delay => setTimeout(updateRebuyCartVariantTitles, delay));
};

document.addEventListener("rebuy:cart.ready", scheduleRebuyCartUpdates);
document.addEventListener("rebuy:cart.add", scheduleRebuyCartUpdates);
